import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/(app)/dashboard/organisation/")({
  beforeLoad: () => {
    throw redirect({ to: "/dashboard/organisation/profile" });
  },
});
